var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('a',{attrs:{"href":"https://neutron.sg/","target":"_blank","rel":"noopener noreferrer"}},[_c('el-image',{staticClass:"logo",attrs:{"src":_vm.logo}}),_c('span',[_vm._v("© "+_vm._s(_vm.year)+" Powered by NeuCommerce")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }